var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header"},[_c('h1',{staticClass:"app-header__title"},[_vm._v("Eternal Draft Pick Guide")])])}]

export { render, staticRenderFns }